import { render, staticRenderFns } from "./redemption-code.vue?vue&type=template&id=f9a0c0b0"
import script from "./redemption-code.vue?vue&type=script&lang=js"
export * from "./redemption-code.vue?vue&type=script&lang=js"
import style0 from "./redemption-code.vue?vue&type=style&index=0&id=f9a0c0b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports